import { useState } from 'react';
import { Container } from './styled';
import { Charts, ChartFull } from '../../../../../components';
import Colors from '../../../../../constants/colors.json';
import { GiResize } from "react-icons/gi";

export function ChartGroups({ groups, objKey }) {

    const [openFullChart, setOpenFullChart] = useState(false);

    function createLabels(array, key) {
        const value = new Set();
        array.forEach(objeto => {
            value.add(objeto[key]);
        });
        return Array.from(value);
    };
    function mountGroups(array, key) {
        const subArray = {};
        array.forEach(objeto => {
            const value = objeto[key];
            if (!subArray[value]) {
                subArray[value] = [];
            }
            subArray[value].push(objeto);
        });
        return Object.values(subArray);
    };
    const generateChartData = (data) => {
        const groupsMounted = mountGroups(data, 'setor');
        const datasets = groupsMounted.map((group, index) => {
            return {
                label: `${group[0].setor.charAt(0).toUpperCase() + group[0].setor.slice(1).toLowerCase()}`,
                data: group?.map(item => (item?.tempo_medio)),
                backgroundColor: Colors[index],
                borderColor: Colors[index],
                borderWidth: 2,
                fill: false,
            }
        });
        const chartData = {
            labels: createLabels(data, objKey),
            datasets: datasets
        };
        return chartData
    };

    return (
        <>
            <Container>
                <div className='full--'>
                    <span onClick={() => setOpenFullChart(true)}>
                        <GiResize fontSize={'1.75rem'} />
                    </span>
                </div>
                <div className='--chart'>
                    <Charts
                        type='Line'
                        data={generateChartData(groups)}
                    />
                </div>
            </Container >
            {(openFullChart) &&
                (<ChartFull
                    onClose={() => setOpenFullChart(false)}
                    title={`Tempo de espera por setores`}
                    dataChart={
                        {
                            type: "Line",
                            data: generateChartData(groups)
                        }
                    }
                />)
            }
        </>
    );
}
